import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { isValidValue } from "utils";
import { useSidebarContext } from "./SidebarStateContext";
import { specialIndex } from "../constant";

// Context shape
const MenuSelectionContext = createContext({
    selectedIndex: null,
    setSelectedIndex: () => undefined,
    open: false,
    toggleSelectedIndex: () => undefined,
});

export const MenuSelectionProvider = ({ children }) => {
    // states
    const [selectedIndex, setSelectedIndex] = useState(null);
    
    const { showSidebar } = useSidebarContext();

    // toggle selectedIndex between "specialIndex" and null
    const toggleSelectedIndex = useCallback(() => {
        setSelectedIndex((prev) => (isValidValue(prev) ? null : specialIndex));
    }, []);

    // reset selectedIndex whenever any sidebar opens
    useEffect(() => {
        if (showSidebar) {
            setSelectedIndex(null);
        }
    }, [showSidebar]);

    // memoized context value
    const value = useMemo(() => {
        const isOpen = isValidValue(selectedIndex) && selectedIndex !== specialIndex;
        return {
            selectedIndex,
            setSelectedIndex,
            open: isOpen,
            toggleSelectedIndex,
        };
    }, [selectedIndex, toggleSelectedIndex]);

    return (
        <MenuSelectionContext.Provider value={value}>
            {children}
        </MenuSelectionContext.Provider>
    );
};

// consumer hook
export const useMenuSelectionContext = () => useContext(MenuSelectionContext);
